export default __webpack_public_path__ + "static/media/logo-lmtr-rvb-variante-jaune-2019-09-17.75c44b26.png";